<template>
  <div
    class="report-section-item relative flex-grow"
    :class="{
      'mode-edit-focused': mode === 'edit' && isFocused && !isDragging,
      'mode-edit-unfocused': mode === 'edit' && !isFocused && !isDragging,
      'mode-edit-unfocused-dragging': isDragging,
      'mode-preview': mode === 'preview',
      'mode-dragging': mode === 'dragging'
    }"
    :style="{ padding: '4px 40px' }"
    @click="onFocus(true)"
  >
    <div
      v-if="mode === 'dragging'"
      class="absolute left-0 top-0 z-10 h-full w-full flex-grow"
      @mouseup="$emit('drop-graph')"
    ></div>
    <div
      class="absolute top-0 left-0 flex justify-end flex-shrink-0"
      :style="{ padding: '4px 8px', width: '40px' }"
    >
      <div
        v-if="mode === 'edit' || mode === 'dragging'"
        class="handle cursor-grab"
      >
        <!-- <i class="fas fa-grip-vertical text-xs" /> -->
        <BlIcon
          icon="drag"
          color="slate-8"
          :style="{ height: '20px', width: '20px' }"
        />
      </div>
    </div>
    <div v-if="section.kind == 'text' || section.kind.includes('heading')">
      <TextEditor
        :section="section"
        :mode="mode"
        :isFocused="isFocused"
        @change-saving="$emit('change-saving', $event)"
        @change-focus-id="$emit('change-focus-id', $event)"
      />
    </div>

    <div
      v-if="section.kind.includes('graph')"
      class="w-full flex flex-wrap oject-center justify-center"
    >
      <ReportGraph
        :section="section"
        :mode="mode"
        :isFocused="isFocused"
        :isDragging="isDraggingGraph"
        @change-saving="$emit('change-saving', $event)"
        @change-focus-id="$emit('change-focus-id', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import TextEditor from "./TextEditor.vue";
import ReportGraph from "./ReportGraph.vue";

import BlIcon from "../../BlIcon.vue";

export default {
  name: "SectionItem",
  components: {
    TextEditor,
    ReportGraph,
    BlIcon
  },
  props: {
    section: { type: Object },
    mode: { type: String }, // dragging | edit | preview
    isFocused: { type: Boolean, default: false },
    isDragging: { type: Boolean, default: false },
    isDraggingGraph: { type: Boolean, default: false }
    // @change-saving
    // @change-focus-id
    // @drop-graph
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions(["deleteSection"]),
    onFocus(val) {
      if (this.mode === "edit" && val) {
        this.$emit("change-focus-id", this.section.id);
      } else {
        this.$emit("change-focus-id", 0);
      }
    },
    removeSection(id) {
      this.deleteSection({ id });
    }
  }
};
</script>

<style lang="scss">
.report-section-item {
  &.mode-edit-focused {
    border-style: solid;
    border-radius: 4px;
    border-width: 4px;
    border-color: var(--Light-Purple-2, #b3a7d1);
  }
  &.mode-edit-unfocused {
    border-style: solid;
    border-radius: 4px;
    border-width: 4px;
    border-color: transparent;
    &:hover {
      border-color: var(--Light-Purple-1, #e7e0ec);
    }
  }
  &.mode-edit-unfocused-dragging {
    border-style: solid;
    border-radius: 4px;
    border-width: 4px;
    border-color: transparent;
  }
  &.mode-preview {
    border-style: solid;
    border-radius: 4px;
    border-width: 4px;
    border-color: transparent;
  }
  &.mode-dragging {
    border-style: solid;
    border-radius: 4px;
    border-width: 4px;
    border-color: transparent;
    &:hover {
      border-top-color: var(--Light-Purple-1, #e7e0ec);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/editor/SectionItem.vue